<h2>Delete message?</h2>
<h3>Are you sure you want to delete the message. This actions can not be reversed.</h3>
<div class="d-flex justify-content-end align-items-center">
  <button [mat-dialog-close]="false">CANCEL</button>
  <button [mat-dialog-close]="true">DELETE</button>
</div>
